import { Box, CircularProgress } from '@mui/material';

import PropTypes from 'prop-types';
import React from 'react';

/**
 *
 *
 * @export
 * @param {import('@mui/material').BoxProps & { loading?: boolean, children?: React.ReactNode }} { loading = true, children, ...remain }
 * @returns {JSX.Element}
 */
export function Loader({ loading = true, children, sx, ...remain }) {
    return loading ? (
        <Box
            data-testid="loader"
            alignItems="center"
            backgroundColor="rgba(255,255,255,0.9)"
            display="flex"
            justifyContent="center"
            sx={theme => ({
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: theme.zIndex.loadingWrapper,
                ...(typeof sx === 'function' ? sx(theme) : sx),
            })}
            {...remain}
        >
            <CircularProgress />
        </Box>
    ) : (
        children || null
    );
}

Loader.propTypes = {
    loading: PropTypes.bool,
    children: PropTypes.node,
    sx: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};

export default Loader;
